import React, { useState, useMemo } from 'react';
//import { gql, useLazyQuery } from '@apollo/client';
//import { ApolloClient } from "@apollo/client";
//import { apolloConfig } from "../../settings/apollo";
import { Cookies } from "react-cookie";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'; 
import { makeStyles } from '@material-ui/core/styles';
import { Container, Link, Box } from '@material-ui/core';
import Authlayout from '../../hoc/AuthLayout/AuthLayout';
import AuthForm from '../../common/components/AuthForm/AuthForm';
import AuthFormField from '../../common/components/AuthForm/AuthFormField/AuthFormField';
import AuthFormSubmit from '../../common/components/AuthForm/AuthFormSubmit/AuthFormSubmit';
import AuthAlert from '../../common/components/AuthAlert/AuthAlert';
import AuthTextBlock from '../../common/components/AuthTextBlock/AuthTextBlock';
//import { useLinkedIn } from 'react-linkedin-login-oauth2';
//import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png';
//import { GoogleOAuthProvider } from '@react-oauth/google';
//import Google from '../google/google.jsx'
//import Facebook from '../facebook/facebook';
import { useCheckMail } from '../../hooks/useCheckMail';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../settings/firebase.js";
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';

//const client = new ApolloClient(apolloConfig);

/*const LOGIN = gql`
  mutation login($email:String!, $password:String){
    login(email:$email, password:$password){
      token
    }
  }
`;*/
/*const LOGIN_WITH_ReCaptcha = gql`
  mutation loginWithReCaptcha($email:String!, $password:String, $reCaptcha: String){
    loginWithReCaptcha(email:$email, password:$password, reCaptcha: $reCaptcha){
      token
    }
  }
`;
const LOGIN_WITH_LINKEDIN  = gql`
    mutation loginWithLinkedin ($linkedinAccessToken: String){
        loginWithLinkedin(linkedinAccessToken: $linkedinAccessToken){
          _id,
          userRole,
          token
        }
  }
`;
const LOGGED_USER = gql`
  query loggedUser {
    user {
      username,
      role
    }
  }
`;*/
/*const GET_LINKEDIN_AUTHORIZATION = gql`
query getAuthorization($code: String, $redirectUri: String){
    getAuthorization(code: $code, redirectUri: $redirectUri)
  }
`;*/

const useStyles = makeStyles(theme => ({
  container: {
    zIndex:2,
  },
  formLink: {
    color: theme.palette.common.gamsPetroleumBlue,
    textDecoration: 'underline',
  },
}));


/*const Login = (props) => {
  const redirectUri = window.location.protocol + '//' + window.location.host + '/linkedin/authorization';
  
  const { linkedInLogin } = useLinkedIn({
    clientId: '77ia0jbfkyzcou',
    redirectUri,
    scope: 'r_emailaddress r_liteprofile',
    onSuccess: (code) => {
        getLinkedinAuthorization({
          variables: {
            code,
            redirectUri,
          },
        })
    },
    onError: (error) => {
      console.log(error);
    },
  });*/

const Login = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const referral = new URLSearchParams(location.search).get("referral");
  //const [login] = useMutation(LOGIN, {client});
  //const [loginWithReCaptcha] = useMutation(LOGIN_WITH_ReCaptcha, {client})
  //const [loginWithLinkedin] = useMutation(LOGIN_WITH_LINKEDIN, {client});
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSigningIn, setIsSigningIn] = useState(false);

  /*function onLinkedinAuthorization(accessToken){
    loginWithLinkedin({
      variables: {
        linkedinAccessToken: accessToken
    },
    }).then(async (res) => {
      const user=res.data.loginWithLinkedin;
      await afterLogin(
        {username: user._id,
        role: user.userRole}, 
        user.token)
    }).catch((error) => {
      console.log(error)
    });
 }*/
  /*const afterLogin = async function({username,role}, token){
    setHasError(false);
    const cookies = new Cookies();
    await cookies.set('jwt', token);
    client.writeQuery({
      query : LOGGED_USER,
      data: {
        user: {
          username,
          role,
        },
      },
    });
    window.location.assign('/')
  }*/

  const validationSchema = useMemo(() => {
    const schema = {
      username: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    };

    // Aggiungi validazione password solo se showPassword è true
    if (showPassword) {
      schema.password = yup
        .string('Enter your password')
        .required('Password is required');
    }

    return yup.object(schema);
  }, [showPassword]);

  //const setJwt = useAppStore((state) => state.setJwt);
  const { mutateAsync: checkMail, isPending: isCheckingMail } = useCheckMail();
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      //keepMeLoggedIn: false
    },
    validationSchema: validationSchema, 
    onSubmit: async (values, { setSubmitting }) => {
     
      if (!showPassword) {
        
        try {
          const result = await checkMail(values.username);
          
          if (result.statusCode === 404 && result.status === 'USER_NOT_FOUND') {
            setHasError(true);
            setErrorMsg('Email non valida');
            setShowPassword(false);
          } 
          else if (result.statusCode === 403 && result.status === 'USER_EXPIRED') {
            setShowPassword(false);
            setHasError(true);
            setErrorMsg('Account scaduto');
          } 
          else if (result.statusCode === 200 && result.status === 'RESET_PASSWORD') {
            setHasError(false);
            setErrorMsg('');
            setShowPassword(false);
            navigate('/register');
          } 
          else if (result.statusCode === 200 && result.status === 'USER_EXISTS') {
            setShowPassword(true);
            setHasError(false);
            setErrorMsg('');
          } 
          
          else {
            setHasError(true);
            setErrorMsg('Errore durante la verifica dell\'email');
            setShowPassword(false);
          }
          
        } catch (error) {
          console.error('checkMail error:', error);
          setHasError(true);
          setErrorMsg('Errore durante la verifica dell\'email');
          setShowPassword(false);
        }
        setSubmitting(false);
        return;
      }
      
      // Secondo step: login con password
      // Firebase App Check gestisce automaticamente la validazione ReCAPTCHA
      try {
        setIsSigningIn(true);
        const userCredential = await signInWithEmailAndPassword(auth, values.username, values.password);
        const user = userCredential.user;
        
        if (!user.emailVerified) {
          setErrorMsg('Devi verificare la tua email prima di accedere.');
          setHasError(true);
          setSubmitting(false);
          setIsSigningIn(false);
          return;
        }
        const idToken = await user.getIdToken(/* forceRefresh */ true);
        //setJwt(idToken || '');
        const cookies = new Cookies();
        await cookies.set('jwt', idToken);     
        setSubmitting(false);
        setIsSigningIn(false);
        navigate('/');
        
      } catch (error) {
        setSubmitting(false);
        setIsSigningIn(false);
        setHasError(true);
        
        let errorMessage = 'Errore durante il login';
        
        if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
          errorMessage = 'Credenziali non valide';
        } else if (error.code === 'auth/user-not-found') {
          errorMessage = 'Utente non trovato';
        } else if (error.code === 'auth/invalid-email') {
          errorMessage = 'Email non valida';
        } else if (error.code === 'auth/user-disabled') {
          errorMessage = 'Account disabilitato';
        } else if (error.code === 'auth/too-many-requests') {
          errorMessage = 'Troppi tentativi. Riprova più tardi';
        } else {
          errorMessage = error.message || 'Errore durante il login';
        }
        
        setErrorMsg(errorMessage);
      }
    },
  });
  
  /* LinkedIn authorization - attualmente non utilizzato
  const [getLinkedinAuthorization,{loading, error,data}] = useLazyQuery(GET_LINKEDIN_AUTHORIZATION, {
    client,
    fetchPolicy: "network-only",
  });
  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;
  if(data && data.getAuthorization!==null){
    onLinkedinAuthorization(data.getAuthorization);
  }
  */
  
  return (
    <Authlayout>
      <Container maxWidth="md" className={classes.container}>

        { hasError ?
          <AuthAlert errorMsg={errorMsg} />
        : null }

        <AuthForm
          formHandleSubmit={formik.handleSubmit}
          formTitle={'Log In'}
          formSubtitle={<AuthTextBlock
            cta={true}
            ctaText="Need a GAMS account?"
            ctaRoute={referral ? `/register/${referral}` : "/register"}
            ctaBtnText="Create an account"
          />}
          formFooter={
            <>
              <Link component={RouterLink} className={classes.formLink} to={referral ? `/forgot-password?referral=${referral}` : "/forgot-password"}>Forgot password?</Link>
            </>
          }
        >
          <AuthFormField
            fieldType={'text'}
            fieldGrid={12}
            fieldName={'username'}
            fieldLabel={'Email'}
            fieldValue={formik.values.username.trim()}
            fieldHandleChange={formik.handleChange}
            fieldError={formik.touched.username && Boolean(formik.errors.username)}
            fieldHelperText={formik.touched.username && formik.errors.username}
          />
          {showPassword && (
            <AuthFormField
              fieldType={'password'}
              fieldGrid={12}
              fieldName={'password'}
              fieldLabel={'Password'}
              fieldValue={formik.values.password}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.password && Boolean(formik.errors.password)}
              fieldHelperText={formik.touched.password && formik.errors.password}
            />
          )}
          {isCheckingMail || isSigningIn ? (
            <Box display="flex" justifyContent="center" width="100%">
              <LoadingSpinner styles={{ minHeight: '36px', padding: '8px 0' }} />
            </Box>
          ) : (
            <AuthFormSubmit
              textSubmit={showPassword ? 'Log In' : 'Avanti'}
            />
          )}
        </AuthForm>
        {/*<Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingTop={5}
          mt={0}
          mb={1.2}
          width="100%"
        >*/}
          {/* LinkedIn login */}
      {/*<img
        onClick={linkedInLogin}
        src={linkedin}
        alt="Sign in with LinkedIn"
        style={{ maxWidth: '180px', cursor: 'pointer' }}
      />*/}

      {/* Google login */}
      {/*<div style={{ width: '182px', cursor: 'pointer', marginTop: '5px' }}>
        <GoogleOAuthProvider clientId="918629219103-d59k7qnkieum6rejoin797p9dbk2vsvu.apps.googleusercontent.com">
          <Google />
        </GoogleOAuthProvider>
      </div>*/}

      {/* Facebook login */}
      {/*<div style={{ width: '180px', cursor: 'pointer', marginTop: '5px' }}>
        <Facebook />
      </div>

        </Box>*/}
      </Container>
    </Authlayout>
  );
}

export default Login;
